<template>
  <div class="about-main-text" v-if="page && page.about">
    <div class="container">
      <div class="col-md-12">
        <div v-html="page.about.text_lead" class="lead lead-intro col-md-12"/>
        <h1>{{ page.about.title }}</h1>
      </div>
    </div>

    <div class="container">
      <div class="col-md-8">
        <div class="text-blow-wrap">
          <div class="font-grotesque" v-html="page.about.text_principle_title"/>
          <div v-text-blow v-html="page.about.text_principle"/>
        </div>
      </div>
      <div class="col-md-2 col-sm-2 col-stat font-grotesque">
        <!-- <h3 style="margin-left: -19px;margin-bottom: 20px;">┌(&nbsp;ಠ_ಠ)┘</h3> -->
        <!-- <a href="https://300.pravo.ru/rating/499/">
          <p><img src="/static/pravo-300.png"/></p>
        </a> -->
      </div>
    </div>
    <div class="container">
      <div class="col-md-8">
        <div class="text-blow-wrap">
          <div class="font-grotesque" v-html="page.about.text_price_title"/>
          <div v-text-blow v-html="page.about.text_price"/>
        </div>
      </div>
      <!-- <div class="col-md-3 col-sm-2 col-stat font-grotesque">
        <h3>100&nbsp;000&nbsp;₽</h3>
        <p class="small">месяц работы юриста</p>
      </div> -->
    </div>
    <div class="container">
      <div class="col-md-8">
        <div class="text-blow-wrap">
          <div class="font-grotesque" v-html="page.about.text_geo_title"/>
          <div v-text-blow v-html="page.about.text_geo"/>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
  name: 'aboutMainText',
  computed: mapGetters({
    page: 'page',
  }),
};
</script>





// WEBPACK FOOTER //
// src/components/AboutMainText.vue